export default function AskEllie() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Ask Ellie</h1>
      <p className="text-gray-600">Interact with Ellie, your AI analyst</p>
    </div>
  );
}


